export default "__VITE_ASSET__FGJe8NIs__"